// src/pages/magasin/SuiviRecuperation.jsx
import React, { useState, useEffect } from 'react';
import {
  Container, Typography, Box, Card, CardContent, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, Alert, CircularProgress,
  Button, Grid
} from '@mui/material';

import ArrowBack from '@mui/icons-material/ArrowBack';
import Person from '@mui/icons-material/Person';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';


export default function SuiviRecuperation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    axios.get(`${API_URL}/recuperation/suivi/${id}`, { headers })
      .then(res => setData(res.data))
      .catch(() => alert('Erreur lors du chargement du suivi'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <Container sx={{ textAlign: 'center', mt: 10 }}>
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>Chargement du suivi...</Typography>
    </Container>
  );

  if (!data?.success) return <Alert severity="error">Impossible de charger le suivi</Alert>;

  const { demande, historique_recuperations } = data;

  const getEtatChip = (etat) => {
    const colors = {
      bon: 'success',
      abime: 'warning',
      irreparable: 'error'
    };
    const labels = {
      bon: 'Bon état',
      abime: 'Abîmé',
      irreparable: 'Irréparable'
    };
    return <Chip label={labels[etat]} color={colors[etat]} size="small" />;
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)} sx={{ mb: 3 }}>
        Retour
      </Button>

      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Suivi Récupération – Demande #{demande.id}
      </Typography>

      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="text.secondary">Demandeur</Typography>
              <Typography variant="h5">{demande.demandeur}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="text.secondary">Statut</Typography>
              <Chip
                label={demande.status === 'completement_recupere' ? 'Récupérée' : 'En cours'}
                color={demande.status === 'completement_recupere' ? 'success' : 'warning'}
                sx={{ mt: 1 }}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" color="text.secondary">Dernière récupération</Typography>
              <Typography variant="h5">
                {demande.date_recuperation ? new Date(demande.date_recuperation).toLocaleDateString('fr-FR') : '—'}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Typography variant="h5" gutterBottom>
        Historique des récupérations
      </Typography>

      {historique_recuperations.length === 0 ? (
        <Alert severity="info" sx={{ my: 4 }}>
          Aucune récupération enregistrée pour cette demande
        </Alert>
      ) : (
        <TableContainer component={Paper} elevation={4}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.100' }}>
                <TableCell><strong>Matériel</strong></TableCell>
                <TableCell align="center"><strong>Qté</strong></TableCell>
                <TableCell><strong>État</strong></TableCell>
                <TableCell><strong>Observations</strong></TableCell>
                <TableCell><strong>Date</strong></TableCell>
                <TableCell><strong>Magasinier</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historique_recuperations.map((rec, i) => (
                <TableRow key={i} hover>
                  <TableCell>{rec.materiel}</TableCell>
                  <TableCell align="center"><strong>{rec.quantite_recuperee}</strong></TableCell>
                  <TableCell>{getEtatChip(rec.etat)}</TableCell>
                  <TableCell>{rec.observations || '—'}</TableCell>
                  <TableCell>{rec.date_recuperation}</TableCell>
                  <TableCell>
                    <Chip icon={<Person />} label={rec.magasinier} size="small" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
}